import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "journal-content" }
const _hoisted_2 = { class: "journal-menu" }
const _hoisted_3 = { class: "journal-btns" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_6 = { style: {"margin-top":"10px","padding":"0 10px","box-sizing":"border-box"} }
const _hoisted_7 = {
  key: 0,
  class: "journal-list"
}
const _hoisted_8 = {
  key: 1,
  class: "empty-text"
}
const _hoisted_9 = {
  key: 1,
  class: "markdown-content"
}
const _hoisted_10 = { class: "title_content" }
const _hoisted_11 = { class: "date-picker-title" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "date-picker-label" }, "更新日期", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_15 = { class: "editor-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelpSearchBar = _resolveComponent("HelpSearchBar")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_v_md_editor = _resolveComponent("v-md-editor")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_HelpSearchBar, { onHelpScreenQuery: _ctx.helpScreenQuery }, null, 8, ["onHelpScreenQuery"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.newlyAdded('new')))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _ctx.deleteItem
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_el_input, {
            placeholder: "请输入关键字",
            modelValue: _ctx.keyword,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.keyword = $event)),
            class: "input-with-select"
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_button, {
                icon: "el-icon-search",
                onClick: _ctx.getUpdateLog
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode(_component_el_scrollbar, null, {
          default: _withCtx(() => [
            (_ctx.updateLogList.length)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.updateLogList, (item, index) => {
                    return (_openBlock(), _createBlock("div", {
                      class: ["journal-li", item.id == _ctx.curSelectId ? 'active' : ''],
                      key: index,
                      onClick: ($event: any) => (_ctx.clickItem(item))
                    }, _toDisplayString(item.date), 11, ["onClick"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (!_ctx.updateLogList.length)
              ? (_openBlock(), _createBlock("p", _hoisted_8, "暂无数据"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      (_ctx.updateLogList.length)
        ? (_openBlock(), _createBlock(_component_el_pagination, {
            key: 0,
            class: "el-pagination",
            background: "",
            onCurrentChange: _ctx.getUpdateLog,
            currentPage: _ctx.pages,
            "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => (_ctx.pages = $event)),
            layout: "total, prev, next, jumper",
            total: _ctx.total
          }, null, 8, ["onCurrentChange", "currentPage", "total"]))
        : _createCommentVNode("", true),
      (_ctx.curSelectId)
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.updateDate,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateDate = $event)),
                  type: "date",
                  placeholder: "选择日期",
                  style: {"width":"100%"},
                  disabled: _ctx.curSelectId && _ctx.curSelectId != 'new'
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _createVNode(_component_el_button, {
                type: "danger",
                class: "btn-left",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.curSelectId = ''))
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.btnMarkdownSave
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode(_component_v_md_editor, {
                class: "editor-height",
                modelValue: _ctx.mdEditorMsg,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.mdEditorMsg = $event)),
                "disabled-menus": [],
                "right-toolbar": "preview sync-scroll fullscreen",
                onSave: _ctx.markdownSave,
                onUploadImage: _ctx.handleUploadImage,
                ref: "markdownRef"
              }, null, 8, ["modelValue", "onSave", "onUploadImage"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}